import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
import { classNames, responsiveVariables } from "../../utils/helpers";
import s from './Image.module.css';
export const Image = ({ src, alt, width, height, onLoad, onError, fallback, displayMode, borderRadius, className, attributes, }) => {
    const [status, setStatus] = React.useState('loading');
    const baseClassNames = classNames(s.root, borderRadius && s[`--radius-${borderRadius}`], displayMode && s[`--display-mode-${displayMode}`], className);
    const imgClassNames = classNames(s.image, baseClassNames);
    const fallbackClassNames = classNames(s.fallback, baseClassNames);
    const style = Object.assign(Object.assign({}, responsiveVariables('--st-image-w', width)), responsiveVariables('--st-image-h', height));
    const handleLoad = (e) => {
        setStatus('success');
        onLoad === null || onLoad === void 0 ? void 0 : onLoad(e);
    };
    const handleError = (e) => {
        setStatus('error');
        onError === null || onError === void 0 ? void 0 : onError(e);
    };
    if (process.env.NODE_ENV === 'development') {
        if (borderRadius === 'round') {
            if (width !== height) {
                // eslint-disable-next-line no-console
                console.warn('STARC: To achieve a round effect, the width and height should be the same');
            }
        }
    }
    if ((status === 'error' || !src) && !!fallback) {
        if (typeof fallback === 'string') {
            return (_jsx("img", { src: fallback, alt: alt, role: alt ? undefined : 'presentation', className: fallbackClassNames, style: style }));
        }
        return (_jsx("div", { className: fallbackClassNames, style: style, children: fallback }));
    }
    return (_jsx("img", Object.assign({ "data-testid": "st-image" }, attributes, { src: src, alt: alt, role: alt ? undefined : 'presentation', onLoad: handleLoad, onError: handleError, className: imgClassNames, style: style })));
};
